import { create } from 'zustand';

export type JarvisState = 'idle' | 'listening' | 'thinking' | 'speaking';

interface JarvisStateStore {
  state: JarvisState;
  setState: (state: JarvisState) => void;
  lastResponse: string;
  setLastResponse: (response: string) => void;
  confidence: number;
  setConfidence: (confidence: number) => void;
}

export const useJarvisState = create<JarvisStateStore>((set) => ({
  state: 'idle',
  setState: (state) => set({ state }),
  lastResponse: '',
  setLastResponse: (response) => set({ lastResponse: response }),
  confidence: 1,
  setConfidence: (confidence) => set({ confidence }),
}));
